import { render, staticRenderFns } from "./QuestionTrainingCamp.vue?vue&type=template&id=3ace6b41&"
import script from "./QuestionTrainingCamp.vue?vue&type=script&lang=js&"
export * from "./QuestionTrainingCamp.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTrainingCamp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports